<div class="header" #header (scroll)="onScroll($event)">
  <div class="first-column"></div>
  <div class="groups">
    @for (group of resources() | resourcePagination : currentPage() : paginationStep(); track group.id) {
      <div class="group">
        <div class="title">{{ group.label }}</div>
        <div class="resources">
          @for (resource of group.tasksGroups; track resource.id) {
            <div class="resource" [style.width.px]="resourceWidth()">{{ resource.label }}</div>
          }
        </div>
      </div>
    }
  </div>
</div>
